import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/lib/api'
import { useT } from '@/i18n/I18nProvider'

type Check = { ok: boolean; details?: unknown; error?: string }

export function AdminPlatformHealthPage() {
  const t = useT()
  const health = useQuery({
    queryKey: ['admin-platform-health'],
    queryFn: () => apiClient.get<Record<string, Check>>('/admin/platform-health'),
    refetchInterval: 30_000,
  })

  if (health.isLoading) return <p>{t('common.loading')}</p>
  if (health.isError || !health.data) return <p>{t('common.error')}</p>

  return (
    <div>
      <h1 className="text-2xl font-semibold mb-4">{t('admin.health.title')}</h1>
      <div className="space-y-3">
        {Object.entries(health.data).map(([name, check]) => (
          <div
            key={name}
            className="p-3 rounded border"
            style={{ borderColor: check.ok ? 'var(--color-border)' : 'var(--color-critical)' }}
          >
            <div className="flex items-center gap-2 mb-1">
              <span
                className="inline-block w-2 h-2 rounded-full"
                style={{ background: check.ok ? 'var(--color-success)' : 'var(--color-critical)' }}
              />
              <span className="font-medium">{name}</span>
            </div>
            {check.error && <p className="text-xs" style={{ color: 'var(--color-critical)' }}>{check.error}</p>}
            {check.details !== undefined && (
              <pre className="text-xs opacity-80 overflow-auto mt-1">{JSON.stringify(check.details, null, 2)}</pre>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}
